export default __webpack_public_path__ + "static/media/tela_cloudmanagedservicespremier.87fe8ad7.png";